import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { ToastData } from 'context/ToastProvider/types';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { useToast } from 'hooks/useToast';
import { IDeposit } from 'interfaces/profile.interface';
import React, { FC, useEffect } from 'react';
import { useTruckerNavigation } from 'hooks/useNavigation';
import Footer from './Footer';
import Approved from './States/Approved';
import ProcessingProfile from './States/ProcessingProfile';
import RequiresUpdate from './States/RequiresUpdate';
import Unsearched from './States/Unsearched';

const statusComponentMap = {
  PROFILE_APPROVED: <Approved />,
  UNSEARCHED_PROFILE: <Unsearched />,
  PROCESSING_PROFILE: <ProcessingProfile />,
  REQUIRES_UPDATE: <RequiresUpdate />,
};

const Deposit: FC<IDeposit> = ({ grStatus, proposalId }) => {
  const { addToast } = useToast();
  const { setStorageData } = useLocalStorage();

  const { handleNavigation } = useTruckerNavigation();

  const statusComponent = statusComponentMap[grStatus] ?? null;

  /* istanbul ignore next */
  function handleClickAction() {
    handleNavigation('/viagens');
  }

  function handleNotificationProposalConfirmedSuccess(dataEvent: CustomEvent) {
    const dataToast = dataEvent.detail;

    const toastObject: ToastData = {
      heading: dataToast.isReject ? dataToast.message : '',
      message: dataToast.isReject ? '' : dataToast.message,
      type: dataToast.isReject ? 'neutral' : 'success',
      buttonOne: dataToast.isReject
        ? undefined
        : { text: 'Monitorar viagem', onClick: handleClickAction, variant: 'secondary', size: 'small' },
    };
    addToast(toastObject);
  }

  function handleNotificationProposalConfirmedError(dataEvent: CustomEvent) {
    const dataToastError = dataEvent.detail;

    if (dataToastError.status === 404) {
      setStorageData('showFreightDisabled', true);
      handleNavigation('/meus-fretes');
      return;
    }

    addToast({
      type: 'error',
      message: 'Tente novamente mais tarde',
      heading: 'Não foi possível realizar esta ação',
    });
  }

  useEffect(() => {
    window.addEventListener('proposalConfirmedSuccess', handleNotificationProposalConfirmedSuccess);
    window.addEventListener('proposalConfirmedError', handleNotificationProposalConfirmedError);
    return () => {
      window.removeEventListener('proposalConfirmedSuccess', handleNotificationProposalConfirmedSuccess);
      window.removeEventListener('proposalConfirmedError', handleNotificationProposalConfirmedError);
    };
  }, []);

  return (
    <>
      <FuelFlex
        defaultProps={{ customPadding: `${DS_TOKENS.spacing.km3} ${DS_TOKENS.spacing.km6} ${DS_TOKENS.spacing.km6}` }}
        testId="profile-deposit-component"
      >
        {statusComponent}
      </FuelFlex>

      <Footer proposalId={proposalId} />
    </>
  );
};

export default Deposit;
